import React from 'react'
import { connect } from 'react-redux'
import FunnelBuilder from './FunnelBuilder'
import CalendarView from './CalendarView'
import Analyze from './Analyze'

export default connect(
	(state) => ({ stepper: state.view.stepper.campaign }),
	null,
)(({ stepper, campaignID, mobile }) => {
	const steps = [
		null,
		<FunnelBuilder mobile={Boolean(mobile)} campaignID={campaignID} />,
		<CalendarView />,
		<Analyze />,
	]

	return <div>{steps[stepper]}</div>
})
